export default __webpack_public_path__ + "static/media/warning.bee23c18.svg";